import React, { useState } from "react";
import classes from "../../style/Style.module.css";
import "../../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_UPLOAD_CANCELLED_CHEQUE,
} from "../../Routes";
import axios from "../../libs/axiosConfig";
import Toast from "../../Components/ToastMsg/Toast";
import { ToastContainer, toast } from "react-toastify";
import { selectPanNumber } from "../../Store/panNumberSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectPhoneNumber } from "../../Store/MobileSlice";
// import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";
import NseFatcaEnquiryapi from "../UpdatedPortFolioApis/nseFatcaEnquiryAPI";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import LogoutModal from "../../Components/LogoutModal";
import { setIinNumber } from "../../Store/IINSlice";

const BlankText = () => {
  const phoneNumber = useSelector(selectPhoneNumber);

  const panNumber = useSelector(selectPanNumber);
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  // const location = useLocation();
  // const { INV_Name } = location.state || {};
  const Navigate = useNavigate();
  // const refreshToken = useSelector(selectRefreshToken);
  const [showModal, setShowModal] = useState(false);
  const [CollectBankData, setCollectBankData] = useState("");
  const dispatch = useDispatch();

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const HandleSubmit = async () => {
    try {
      const FristApiResponse = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        {
          nseIINDetails: {
            pan: panNumber,
          },
        }
      );
      const IIN = FristApiResponse.data.body.iin;
      dispatch(setIinNumber(IIN));
      console.log(IIN, "iin is present");
      if (FristApiResponse.data.StatusCode === 200) {
        const FristApiResponseData = FristApiResponse.data;

        const {
          iin,
          primary_distributor,
          iin_confirmation_status,
          iin_consolidated_confirmation_status,
          activation_Status,
          iin_deactivation_reason,
        } = FristApiResponseData.data.body;

        if (activation_Status === "Yes") {
          try {
            // const CustomerKycDetailsResponse = await axios.get(
            //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",
            //   {
            //     headers: {
            //       Authorization: `Bearer ${storedToken}`,
            //       // RefreshToken: refreshToken
            //     },
            //   }
            // );
            // const GetAPIData = CustomerKycDetailsResponse.data.data;
            // console.log(GetAPIData, "Get api data");
            const thirdapi =
              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
            const thirdRequestBody = {
              CustomerKycDetails: {
                request_type: "get",
                mobileNumber: phoneNumber,
                pan: panNumber,
              },
            };
            const GetAPIData = thirdapi.data.body;
            console.log(GetAPIData, "Get api data");
            const { bankAccountNumber, bankIfscCode } = thirdapi.data.body;
            setCollectBankData(thirdapi.data.body);
            NseFatcaEnquiryapi();

            // const FatcaApiResponse = await axios.post(
            //   "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
            //   {
            //     nseFatca: {
            //       mobilenumber:phoneNumber,
            //       pan: panNumber,
            //       iin: FristApiResponseData.body.iin,
            //       investor_name: INV_Name,
            //       app_income_code: GetAPIData.nseIncomeCode,
            //       occ_code: GetAPIData.nseOccupationCode,
            //       dob: GetAPIData.dob,
            //       log_name: GetAPIData.emailId,
            //       country_of_birth: GetAPIData.nseCountryOfBirth,
            //       place_birth: GetAPIData.placeOfBirth,
            //     },
            //   },
            //   {
            //     headers: {
            //       Authorization: `Bearer ${storedToken}`,
            //       RefreshToken: refreshToken

            //     },
            //   }
            // );
          } catch (error) {
            console.error("Error occurred while calling APIs:", error);
            // Toast.error("Error occurred while calling APIs");
          }
        } else {
          if (iin !== "" && primary_distributor !== "Y") {
            Toast.error("iin not confirmed");
          } else if (
            ((iin_confirmation_status === "Y" &&
              iin_consolidated_confirmation_status === "Y") ||
              (iin_confirmation_status === "" &&
                iin_consolidated_confirmation_status === "Y")) &&
            activation_Status !== "Yes"
          ) {
            console.log("2")
            if (iin_deactivation_reason === "Your IIN is Deactivated") {
              Navigate(ROUTE_UPLOAD_CANCELLED_CHEQUE, {
                state: {
                  CollectBankData,
                  IIN,
                },
              });
            } else {
              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                state: { reason: iin_deactivation_reason },
              });
              Toast.error(
                FristApiResponseData.data.message +
                  " " +
                  FristApiResponseData.data.errorMessage
              );
            }
          }
        }
      } else if (FristApiResponse.data.statusCode === 500) {
        // const customerKycApiResponse = await axios.post(
        //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",
        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken,
        //     },
        //   }
        // );
        // const CustomerKycDetails = customerKycApiResponse.data.data;
        // console.log(CustomerKycDetails, "500 this condition work");

        const fifthapi =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const fifthapiRequestBody = {
          CustomerKycDetails: {
            request_type: "get",
            mobileNumber: phoneNumber,
            pan: panNumber,
          },
        };
        const { bankAccountNumber, bankIfscCode } = fifthapi.data.body;

        const CustomerKycDetails = fifthapi.data.body;
        console.log(CustomerKycDetails, "500 this condition work");

        const postApiResponse = await axios.post(
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
          {
            nseCreateCustomer: {
              title: CustomerKycDetails.data.body.panDetails.title,
              inv_name: CustomerKycDetails.data.body.panDetails.inv_name,
              pan: CustomerKycDetails.data.body.pan,
              dob: CustomerKycDetails.data.body.panDetails.dob,
              addr1: CustomerKycDetails.data.body.panDetails.addr1,
              addr2: CustomerKycDetails.data.body.panDetails.addr2,
              city: CustomerKycDetails.data.body.panDetails.city,
              state: CustomerKycDetails.data.body.panDetails.state,
              pincode: CustomerKycDetails.data.body.panDetails.pincode,
              country: CustomerKycDetails.data.body.panDetails.country,
              mobile_no: CustomerKycDetails.data.body.mobileNumber,
              email: CustomerKycDetails.data.body.emailId,
              bank_name: CustomerKycDetails.data.bodybankName,
              acc_no: CustomerKycDetails.data.body.bankAccountNumber,
              acc_type: CustomerKycDetails.data.body.bankAccountType,
              ifsc_code: CustomerKycDetails.data.body.bankIfscCode,
              branch_name: CustomerKycDetails.data.body.bankBranchName,
              branch_addr1: CustomerKycDetails.data.body.bankBranchAddress,
              NOMINEE_OPTED: CustomerKycDetails.data.body.nomineeType,
              no_of_nominee: 0,
              nominee1_name: CustomerKycDetails.data.body.nomineeName,
              nominee1_dob: CustomerKycDetails.data.body.nomineeDob,
              nominee1_relation:
                CustomerKycDetails.data.body.nomineeRelationShip,
              nominee1_percent:
                CustomerKycDetails.data.body.nomineeAllocationPercentage,
              nominee1_guard_name:
                CustomerKycDetails.data.body.nomineeGuardianName,
              nominee1_guard_pan:
                CustomerKycDetails.data.body.data.nomineeGuardianPan,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
              // RefreshToken: refreshToken
            },
          }
        );

        if (
          postApiResponse.status === 200 &&
          postApiResponse.data.statusCode === 200
        ) {
          if (postApiResponse.data.body.iin !== "") {
            const RecallIINDetails = await axios.post(
              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
              {
                nseIINDetails: {
                  pan: panNumber,
                },
              }
            );

            console.log(RecallIINDetails);
          } else {
            Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
              state: { reason: "Your iin account creation failed" },
            });
          }
        } else {
          Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
            state: { reason: "Your iin account creation failed" },
          });
          toast.error(postApiResponse.data.message);
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
      // Toast.error(
      //   error.response.data.errorMessage +
      //     " " +
      //     error.response.data.message || "Error"
      // );
    }
  };

  return (
    <div className="Blank_Text_Main_Container">
      <div className="Blank_Text_Messages_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="NewDexter_Logo">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="BlankText_Screen_Container">
        <p className="Input_Heading_text_iin">Confirmation</p>
        <p className="Input_Heading_text_SubHeading">
          Please click on the IIN Confirmation link shared by NSE with you via
          email and SMS
        </p>
        <button className="Submit_button" onClick={HandleSubmit}>
          Proceed
        </button>
      </div>
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      ;
    </div>
  );
};

export default BlankText;
